// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import type { Office } from '../model/Office.model';
import Loader from '../../elements/Loader';
import LoadFailed from '../../elements/LoadFailed';
import ErrorCapsule from '../../core/exceptions/ErrorCapsule';
import { useDialog } from '../../elements/Dialog';
import CanEdit from '../../elements/CanEdit';

export type OfficesListPageViewProps = {
  offices: null | Array<Office> | ErrorCapsule,
  isAdmin: boolean,
  onDeleteOffice: (id: string) => void,
  onToggleWebCut: (id: string, isWebCutDisabled: boolean) => void,
}

export default function OfficesListPageView({
  offices,
  isAdmin,
  onDeleteOffice,
  onToggleWebCut,
}: OfficesListPageViewProps) {
  const { t } = useTranslation();
  const { confirm } = useDialog();

  if (!offices) return <Loader />;
  if (offices instanceof ErrorCapsule) return <LoadFailed error={offices} />;

  return (
    <div className="offices-list">
      <h1>Офисы</h1>

      <div className="mb-1 text-right">
        <CanEdit><Link to="/org/office-add/" className="btn btn-primary btn-sm">добавить офис</Link></CanEdit>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th>Название</th>
            <th>Франчайзи</th>
            {isAdmin && <th>Резка через сайт</th>}
            <th />
          </tr>
        </thead>
        <tbody>
          {offices.map(({
            id,
            title,
            franchisee,
            notes,
            isWebCutDisabled,
          }) => (
            <tr key={id} className="franchisees-list__franchisee">
              <td>{title}</td>
              <td>{franchisee ? franchisee.title : 'Свой офис'}</td>
              {isAdmin && (
              <td className="text-nowrap">
                {
                  isWebCutDisabled
                    ? <span className="text-muted">запрещена</span>
                    : <span>разрешена</span>
                }
                &nbsp;
                <button
                  type="button"
                  className={isWebCutDisabled ? 'btn btn-outline-secondary btn-sm' : 'btn btn-outline-warning btn-sm'}
                  onClick={e => (
                    isWebCutDisabled
                      ? onToggleWebCut(id, false)
                      : confirm({
                        renderBody: () => `Запрещаем резку через сайт для ${title}? Загрузка лекал в офлайн-приложение продолжит работать.`,
                        handler: () => onToggleWebCut(id, true),
                      })
                  )}
                >
                  {isWebCutDisabled ? 'разрешить' : 'запретить'}
                </button>
              </td>
              )}
              <td className="text-right text-nowrap"><CanEdit>
                <Link to={`/org/office-edit/${id}/`} className="btn btn-primary btn-sm">
                  изменить
                </Link>
                &nbsp;
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={e => confirm({
                    renderBody: () => `Удаляем ${title}?`,
                    handler: () => onDeleteOffice(id),
                  })}
                >
                  удалить
                </button>
              </CanEdit></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
